import { BoxStyleProps } from "@twilio-paste/core/box";

export const wrapperStyle: BoxStyleProps = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden"
};
